import type { FC } from 'react';

import type { IconProps } from './types';

export const Menu: FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill={color}
      d="M73.143 73.143h877.714c40.395 0 73.143 32.747 73.143 73.143s-32.747 73.143-73.143 73.143H73.143C32.748 219.429 0 186.682 0 146.286s32.747-73.143 73.143-73.143zM73.143 438.857h877.714c40.395 0 73.143 32.747 73.143 73.143s-32.747 73.143-73.143 73.143H73.143C32.748 585.143 0 552.396 0 512s32.747-73.143 73.143-73.143zM73.143 804.571h877.714c40.395 0 73.143 32.747 73.143 73.143s-32.747 73.143-73.143 73.143H73.143C32.748 950.857 0 918.11 0 877.714s32.747-73.143 73.143-73.143z"
    />
  </svg>
);

export default Menu;
